import { useState, useEffect, useRef, SetStateAction } from "react";

const tmpReact = {
    useState: function <Type>(
        initialState: Type
    ): [Type, (state: SetStateAction<Type>, cb?: (newState: Type) => void) => void] {
        const [state, setState] = useState<Type>(initialState);
        const cbRef = useRef<(newState: Type) => void>(null);

        const setStateCallback = (state: SetStateAction<Type>, cb?: (newState: Type) => void) => {
            cbRef.current = cb;
            setState(state);
        };

        useEffect(() => {
            if (cbRef.current) {
                cbRef.current(state);
                cbRef.current = null;
            }
        }, [state]);

        return [state, setStateCallback];
    },

    setState: (...args) => {
        return jQuery.extend(true, {}, ...args);
    },

    printClasses: (classes, base_classes = []) => {
        return classes
            ? Array.isArray(classes)
                ? [...classes, ...base_classes].join(" ")
                : base_classes.join(" ") + " " + classes
            : base_classes.join(" ");
    },

    forms: {
        setField: (setState, field, data) => {
            setState((prev) => ({
                prev: {
                    ...prev,
                    [field]: {
                        ...prev[field],
                        ...data,
                    },
                },
            }));
        },

        setFieldInput: (setState, fields, field, data, callback = () => {}) => {
            setState(
                {
                    fields: {
                        ...fields,
                        [field]: {
                            ...fields[field],
                            input: {
                                ...fields[field].input,
                                ...data,
                            },
                        },
                    },
                },
                callback
            );
        },

        setFieldVars: (setState, fields, field, data, callback = () => {}) => {
            setState(
                {
                    fields: {
                        ...fields,
                        [field]: {
                            ...fields[field],
                            vars: {
                                ...fields[field].vars,
                                ...data,
                            },
                        },
                    },
                },
                callback
            );
        },
    },
};

export default tmpReact;
